import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrder } from '../context/OrderContext';
import { Header } from '../layout';

const OrderDetails = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useOrder();
  const [length, setLength] = useState('');
  const [quantity, setQuantity] = useState('');
  const [finish, setFinish] = useState('');

  const finishOptions = [
    { id: 'grezzo', label: 'Grezzo' },
    { id: 'anodizzato', label: 'Anodizzato' },
    { id: 'bianco', label: 'Bianco' },
    { id: 'nero', label: 'Nero' },
    { id: 'ral', label: 'RAL' }
  ];

  const getSupplyTypeLabel = (type) => {
    switch (type) {
      case 'barre':
        return 'Fornitura a Barre';
      case 'misura':
        return 'Fornitura a Misura';
      case 'progettazione':
        return 'Fornitura con Progettazione';
      default:
        return '';
    }
  };

  const getDrainageTypeLabel = (type) => {
    switch (type) {
      case 'foro-int-est':
        return 'Foro Interno-Esterno';
      case 'foro-int':
        return 'Foro Interno';
      case 'foro-est':
        return 'Foro Esterno';
      case 'fresatura':
        return 'Fresatura';
      case 'fresatura-tappo':
        return 'Fresatura con Tappo di Finitura';
      default:
        return '';
    }
  };

  const handleSubmit = () => {
    dispatch({
      type: 'UPDATE_ORDER',
      payload: {
        length: parseInt(length),
        quantity: parseInt(quantity),
        finish
      }
    });
    navigate('/order-summary');
  };

  const renderProcessingDetails = () => {
    const { processing } = state.orderDetails;
    if (!processing?.supplyType) return null;

    return (
      <div className="mb-6 border-t pt-6">
        <h3 className="text-lg font-bold mb-4">Dettagli Lavorazioni</h3>

        <div className="space-y-4">
          <div>
            <span className="font-medium">Tipo Fornitura:</span>{' '}
            {getSupplyTypeLabel(processing.supplyType)}
          </div>

          {processing.barGroups?.length > 0 && (
            <div>
              <span className="font-medium">Configurazioni Barre:</span>
              <div className="ml-4 space-y-2 mt-2">
                {processing.barGroups.map((g, index) => (
                  <div key={index} className="p-3 bg-gray-50 rounded-lg">
                    <div>{g.quantity} {g.quantity === 1 ? 'barra' : 'barre'} da {g.barLength} metri ({g.quantity * g.barLength} mt)</div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {!processing.barGroups && processing.bars?.length > 0 && (
            <div>
              <span className="font-medium">Configurazioni Barre:</span>
              <div className="ml-4 space-y-2 mt-2">
                {processing.bars.map((bar, index) => (
                  <div key={index} className="p-3 bg-gray-50 rounded-lg">
                    <div>Lunghezza: {bar.barLength} metri</div>
                    <div>Quantità: {bar.quantity}</div>
                    {bar.drainage?.needsDrainage && (
                      <div>
                        Scarico Acqua: {getDrainageTypeLabel(bar.drainage.drainageType)}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {processing.stepType && (
            <div>
              <span className="font-medium">Tipo Passo:</span>{' '}
              {processing.stepType === 'standard' ? 'Standard' : 'Personalizzato'}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Header title="Dettagli Ordine" />

      <div className="container mx-auto px-4 py-6">
        <div className="max-w-lg mx-auto bg-white rounded-lg shadow p-6">
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Lunghezza (mm)
            </label>
            <input
              type="number"
              inputMode="numeric"
              pattern="[0-9]*"
              value={length}
              onChange={(e) => setLength(e.target.value)}
              className="w-full px-3 py-3 text-base border rounded-lg"
              placeholder="Inserisci lunghezza"
            />
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Quantità
            </label>
            <input
              type="number"
              inputMode="numeric"
              pattern="[0-9]*"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              className="w-full px-3 py-3 text-base border rounded-lg"
              placeholder="Inserisci quantità"
            />
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Finitura
            </label>
            <div className="grid grid-cols-2 gap-4">
              {finishOptions.map((option) => (
                <button
                  key={option.id}
                  onClick={() => setFinish(option.id)}
                  className={`p-2 border rounded-lg ${finish === option.id
                    ? 'bg-red-50 border-red-500'
                    : 'border-gray-300'
                    }`}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>

          {renderProcessingDetails()}

          <div className="flex space-x-4">
            <button
              onClick={() => navigate(-1)}
              className="flex-1 py-2 px-4 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
            >
              Indietro
            </button>
            <button
              onClick={handleSubmit}
              disabled={!length || !quantity || !finish}
              className="flex-1 py-2 px-4 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:opacity-50"
            >
              Continua
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
